<app-shopping-cart></app-shopping-cart>
<div class="workspace bg-radial starter-plan-page">
  <top-bar
    [titleTranslationCode]="'NAVIGATION.PLANS'"
    [redirectLink]="'../../'"
    [defaultRedirectTranslationCodes]="true"
  >
    <footer>
      <div class="row d-none d-md-flex">
        <div class="col-10">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" aria-current="page">
                <a routerLink="../../">
                  {{ "NAVIGATION.PLANS" | translate }}
                </a>
              </li>
              <li *ngIf="chosenCourse" class="breadcrumb-item active" aria-current="page">
                {{ CourseFilterComponent.getLanguageTranslation(chosenCourse) | translate }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </footer>
  </top-bar>

  <div class="container mt-md-3">
    <div class="row position-relative pb-3">
      <spinner class="w-100 spinner"></spinner>
    </div>

    <section class="mb-4">
      <app-shopping-cart-header
        (currencyChange)="onCurrencyChange($event)"
        [studentId]="studentId"
      ></app-shopping-cart-header>
    </section>

    <section class="mb-4">
      <div [ngClass]="getHeroClass()">
        <div class="course d-flex justify-content-between align-items-center">
          <h4 class="text-white my-1">{{ getLangName() | translate }}</h4>
          <a
            class="btn btn-primary rounded-pill"
            routerLink="/student/courses"
            [queryParams]="{ language: language }"
          >
            {{ 'BUTTON.DETAILS' | translate }}
          </a>
        </div>
      </div>
    </section>

    <section class="text-center mb-4">
      <h6 class="text-uppercase starter-title mb-1">
        {{ 'STARTER_PLAN.TITLE' | translate }}
      </h6>
      <p class="text-uppercase text-muted small mb-0">
        {{ 'STARTER_PLAN.SUBTITLE' | translate }}
      </p>
    </section>

    <section class="mb-5">
      <app-starter-product-card
        [currency]="currency"
        [language]="language"
      ></app-starter-product-card>
    </section>

    <section class="mb-5">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <h6 class="mb-3">
                {{ 'STARTER_PLAN.WHAT_YOU_GET_TITLE' | translate }}
              </h6>
              <ul class="starter-list text-muted small ps-3 mb-3">
                <li>{{ 'STARTER_PLAN.WHAT_YOU_GET_ITEM_1' | translate }}</li>
                <li>{{ 'STARTER_PLAN.WHAT_YOU_GET_ITEM_2' | translate }}</li>
                <li>{{ 'STARTER_PLAN.WHAT_YOU_GET_ITEM_3' | translate }}</li>
                <li>{{ 'STARTER_PLAN.WHAT_YOU_GET_ITEM_4' | translate }}</li>
              </ul>
              <p class="text-muted small mb-2">
                {{ 'STARTER_PLAN.VALIDITY' | translate }}
              </p>
              <p class="text-muted small mb-0">
                {{ 'STARTER_PLAN.ACCESS' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
